// Angular
import { CommonModule } from "@angular/common";
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  NgZone,
  OnInit,
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Router } from "@angular/router";

// Ionic
import {
  IonIcon,
  IonLabel,
  IonTabBar,
  IonTabButton,
  IonTabs,
  IonMenu,
  IonList,
  IonItem,
  IonMenuToggle,
  IonFooter,
  IonModal,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonButton,
  IonTitle,
  IonContent,
  IonInput,
  ModalController,
  AlertController
} from "@ionic/angular/standalone";
// import { OverlayEventDetail } from '@ionic/core/components';

// Capacitor
import { Capacitor } from '@capacitor/core';

// Third party
import { NativeSettings, AndroidSettings } from 'capacitor-native-settings';

// Local library
import {
  CommonFacade,
  PermissionService,
  SessionService
} from "@amwager/data-access";

// Local file
import { GeoLocationService, UnsubscribeObservableService } from "@amwager/util";
import { ITicketSlim, WagerFacade } from "@amwager/wager/data-access";
import { AuthFacade } from "@amwager/authentication/data-access";
import { Subscription, takeUntil } from "rxjs";
import { BetSlipModalComponent } from "@amwager/ticket/feature-ion";
import { FundingComponent } from '@amwager/funding/feature-ion';
import * as _ from 'lodash';
import {
  GUEST,
  IGeoLocationModel,
  STATUS_ACTIVE
} from "@amwager/util-ts";

@Component({
  selector: 'amwager3-tabs-section',
  styleUrls: ['./tabs.section.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    IonTabs,
    IonTabBar,
    IonTabButton,
    IonIcon,
    IonLabel,
    IonMenu,
    IonList,
    IonItem,
    IonMenuToggle,
    IonFooter,
    IonModal,
    IonHeader,
    IonToolbar,
    IonButtons,
    IonButton,
    IonTitle,
    IonContent,
    IonInput,
    FormsModule,
    CommonModule
  ],
  template: `
    <ion-tabs>
      <ion-tab-bar
        *ngIf="isShowFooter"
        slot="bottom"
        class="
          footer-content tw-border-t-[1px]
          tw-border-t-slate-200
          tw-bg-[#2F80EC]
        ">
        <ion-tab-button class="tw-uppercase" (click)="openModalDeposit()" data-cy="open-deposit">
          <img
            class="deposit-icon"
            src="assets/icons/deposit_icon.png"
            alt="deposit icon">
          deposit
        </ion-tab-button>
        <ion-tab-button class="tw-uppercase" (click)="openModalBetSlip()" data-cy="open-betslip">
          <span
            *ngIf="totalTickets.length"
            class="betslip count-ticket tw-bg-[#EB2A2A] tw-text-[#FFFFFF] tw-text-[11px]"
            data-cy="betslip-counter"
          >
            {{ totalTickets.length }}
          </span>
          <img
            class="betslip-icon"
            src="assets/icons/betslip_icon.png"
            alt="betslip icon">
          betslip
        </ion-tab-button>
        <ion-tab-button (click)="openRaces()" class="tw-uppercase" data-cy="open-races">
          <img
            class="races-icon"
            src="assets/icons/races_icon.png"
            alt="races icon">
          races
        </ion-tab-button>
        <ion-tab-button (click)="openPromo()" class="tw-uppercase" data-cy="open-promo">
          <!-- <span class="promo count-ticket tw-bg-[#EB2A2A] tw-text-[#FFFFFF] tw-text-[11px]">
            0
          </span> -->
          <img
            class="promo-icon"
            src="assets/icons/promo_icon.png"
            alt="promo icon">
          promo
        </ion-tab-button>
        <ion-tab-button (click)="openMore()" class="tw-uppercase" data-cy="open-more">
        <img
          class="gear-icon"
          src="assets/icons/gear_icon.png"
          alt="gear icon">
          more
        </ion-tab-button>
      </ion-tab-bar>
    </ion-tabs>
  `
})
export class TabsSectionPageComponent extends UnsubscribeObservableService implements OnInit {
  message = 'This modal example uses the modalController to present and dismiss modals.';

  geoLocation!: IGeoLocationModel;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  events$!: any;
  totalTickets: ITicketSlim[] = [];
  getSelectedEventTrackSubs?: Subscription;

  isShowFooter = false;
  isEventTrackRaceRequestingAPI?: boolean;
  setTimer: any = 0;

  private modal!: HTMLIonModalElement;
  private showAlertInfoHandler?: HTMLIonAlertElement;
  private showAlertErrorHandler?: HTMLIonAlertElement;

  constructor(
    private router: Router,
    private modalCtrl: ModalController,
    private readonly alertCtrl: AlertController,
    private readonly permissionService: PermissionService,
    private geoLocationService: GeoLocationService,
    private readonly commonFacade: CommonFacade,
    private readonly wagerFacade: WagerFacade,
    private readonly authFacade: AuthFacade,
    private readonly cdRef: ChangeDetectorRef,
    private readonly ngZone: NgZone,
    private readonly sessionService: SessionService,
  ){

    super();

    this.commonFacade.setIsShowFooter(true);

    this.commonFacade.isShowFooter$().subscribe((isShow: boolean) => {
      this.isShowFooter = isShow;
      this.cdRef.markForCheck(); // re-render for template
    });

    this.wagerFacade.isEventTrackRaceRequestingAPI$()
      .subscribe((isRequestingAPI: boolean) => {
        this.isEventTrackRaceRequestingAPI = isRequestingAPI;
        this.cdRef.markForCheck(); // re-render for template
      });
  }

  ngOnInit(): void {
    this.wagerFacade.getTicketGeoLocation$().subscribe((response?: IGeoLocationModel) => {
      if (response === undefined) return;
      this.geoLocation = response;
    });

    // this.commonFacade.isShowFooter$().subscribe((isShow: boolean) => {
    //   this.isShowFooter = isShow;
    //   this.cdRef.markForCheck(); // re-render for template
    // });

    // for event name
    this.wagerFacade.getSelectAllEventTrackRace$()
    .pipe(takeUntil(this.toUnsubscribe$))
    .subscribe((res) => {
      this.events$ = res;
    });

    this.wagerFacade.getBets$()
    .pipe(takeUntil(this.toUnsubscribe$))
    .subscribe((response) => {
      // console.log('tab:getBets:',response);
      // show only active ticket
      // response = _.filter(response, ['TicketStatus', STATUS_ACTIVE]);

      response = response?.active;

      if (response !== undefined) {
        response = _.filter(response, { TicketStatus: STATUS_ACTIVE, IsCancelled: false });
        this.totalTickets = response;
        if (response.length) {
          if (response[0].TicketStatus !== 1) {
            this.totalTickets = _.filter(response, (data) => !data.IsCancelled);
          }
        }
      }

      this.cdRef.markForCheck();
    });

    this.authFacade.isLogoutSuccess$().subscribe((isLogout?: boolean) => {
      if (isLogout) {
        this.totalTickets = [];
        this.modalCtrl?.dismiss();
        this.modal?.dismiss();

        this.alertCtrl?.dismiss();
        this.showAlertInfoHandler?.dismiss();
        this.showAlertErrorHandler?.dismiss();

        this.cdRef.markForCheck(); // re-render for template
      }
    });
  }

  goTo(url: string): void {
    this.router.navigate([url])
  }

  async openModalDeposit() {
    if (!navigator.onLine) {
      this.commonFacade.setIsConnectedInternet('TabsSectionPage:openModalDeposit', false);
    }

    if (!this.hasPermission()) {

      if (this.sessionService.getUserEmail() === GUEST || !this.sessionService.hasToken()) {
        this.router.navigate(['login']);
      }
      else {
        this.showAlertInfo('You are not an Identified User.');
        // this.router.navigate(['login']);
      }

      // this.showAlertInfo(
      //   this.sessionService.getUserEmail() === GUEST
      //     ? 'Guest user is not allowed to deposit. Kindly login/signup.'
      //     : 'You are not an Identified User.'
      // );
      return;
    }

    if (this.geoLocation === undefined) {
      const result = await this.geoLocationService.askPermissionGeoLocation();

      if ('latitude' in result && 'longitude' in result) {
        if (result === undefined)
          return;

        if (result.latitude && result.longitude) {
          this.wagerFacade.setGeoLocation({
            CLat: result.latitude, CLon: result.longitude
          },
          'TabsSectionPage:openModalDeposit');
        }

        const modal = await this.modalCtrl.create({
          component: FundingComponent,
        });
        modal.present();

        return;

      }
      else
        if (result.showDeviceSetting)
          this.showAlertError(result.msg, 'Yes');
        else
          this.showAlertError(result.msg, '');
        return;
    }

    this.modal = await this.modalCtrl.create({
      component: FundingComponent,
    });
    this.modal.present();

    // TODO
    // const modal = await this.modalCtrl.create({
    //   component: DepositModalComponent,
    // });
    // modal.present();

    // const { data, role } = await modal.onWillDismiss();

    // if (role === 'confirm') {
    //   this.message = `Hello, ${data}!`;
    // }
  }

  async openModalBetSlip() {
    if (!navigator.onLine) {
      this.commonFacade.setIsConnectedInternet('TabsSectionPage:openModalBetSlip', false);
    }

    if (!this.hasPermission()) {

      if (this.sessionService.getUserEmail() === GUEST || !this.sessionService.hasToken()) {
        this.router.navigate(['login']);
      }
      else {
        this.showAlertInfo('You are not an Identified User.');
      }

      return;
    }

    this.modal = await this.modalCtrl.create({
      component: BetSlipModalComponent,
      cssClass: 'betslip'
    });
    this.modal.present();

    const { data, role } = await this.modal.onWillDismiss();

    if (role === 'confirm') {
      this.message = `Hello, ${data}!`;
    }
  }

  openRaces() {
    if (this.setTimer) {
      clearTimeout(this.setTimer);
    }

    this.setTimer = setTimeout( () => {
      this.wagerFacade.setDefaultEvent(true);
    }, 300);
  }

  async openPromo() {
    if (!navigator.onLine) {
      this.commonFacade.setIsConnectedInternet('TabsSectionPage:openPromo', false);
    }

    if (!this.hasPermission()) {
      if (this.sessionService.getUserEmail() === GUEST || !this.sessionService.hasToken()) {
        this.router.navigate(['login']);
      }
      else this.showAlertInfo('The countdown to your next big win starts soon!');

      return;
    }
    else {
      this.showAlertInfo('The countdown to your next big win starts soon!');
    }
  }

  async openMore() {
    if (!navigator.onLine) {
      this.commonFacade.setIsConnectedInternet('TabsSectionPage:openMore', false);
    }

    if (!this.hasPermission()) {
      if (this.sessionService.getUserEmail() === GUEST || !this.sessionService.hasToken()) {
        this.router.navigate(['login']);
      }
      else this.showAlertInfo('The countdown to your next big win starts soon!');

      return;
    }
    else {
      this.showAlertInfo('The countdown to your next big win starts soon!');
    }
  }

  hasPermission(): boolean {
    if (this.permissionService.isAllowed()) {
      return true;
    }

    return false;
  }

  async showAlertInfo(message: string): Promise<void> {
     this.showAlertInfoHandler = await this.alertCtrl.create({
      header: 'Info',
      message,
      buttons: [
        {
          text: 'Close',
          handler: () => {
            // comment out for now
            // this.ngZone.run(()=>{
            //   this.modalCtrl.dismiss();
            // });
          }
        }
      ]
    });

    await this.showAlertInfoHandler.present();
  }

  async showAlertError(error: string, btn: string): Promise<void> {

    const platform = Capacitor.getPlatform();

    this.showAlertErrorHandler = await this.alertCtrl.create({
      header: 'Error',
      message: error,
      buttons: [
        {
          text: 'Close',
          handler: () => {
            this.ngZone.run(()=>{
              this.modalCtrl.dismiss();
            });
          }
        },
        {
          text: btn,
          handler: () => {
            this.ngZone.run(()=>{
              if (platform === 'android') {
                NativeSettings.openAndroid({
                  option: AndroidSettings.Location,
                });
              }
              this.modalCtrl.dismiss();
            });
          }
        }
      ]
    });

    await this.showAlertErrorHandler.present();
  }

}
